import { render } from "./formContact.vue?vue&type=template&id=10f9781a&scoped=true&class=contact"
import script from "./formContact.vue?vue&type=script&lang=js"
export * from "./formContact.vue?vue&type=script&lang=js"

import "./formContact.vue?vue&type=style&index=0&id=10f9781a&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f9781a"]])

export default __exports__